export default "__VITE_ASSET__BToYTxls__"